(() => {
    'use strict';

    window.sectionsTheme = window.sectionsTheme || {};

    /**
     * Default for values not set.
     */
    const defaultAppName = 'app';
    const defaultDependencies = [];
    const defaultIsDev = false;

    /**
     * Set values if supplied by our php theme file.
     */
    const dependencies = window.sectionsTheme.dependencies || defaultDependencies;
    const appName = window.sectionsTheme.appName || defaultAppName;
    const isDev = ('boolean' === typeof window.sectionsTheme.isDev) ? window.sectionsTheme.isDev : defaultIsDev;

    /**
     * Creates our main application module.  All of our base functionality should
     * be part of this module.
     */
    const app = angular.module(appName, dependencies);

    /**
     * Dynamically configures our module with single page views, if provided elsewhere in the page.
     */
    if(window.sectionsRoutePage && window.sectionsRoutePage.routeProvider) {
        if(isDev) console.log('route received: ', window.sectionsRoutePage);

        app.config(['$routeProvider', ($routeProvider) => {
            window.sectionsRoutePage.routeProvider($routeProvider);
        }]);
    }


    app
        .controller('MainController', ['$window', '$scope', function($window, $scope) {
            let _this = this;

            _this.bodyLock = false;

            _this.closeOverlay = () => {
                let overlay = document.getElementsByClassName('body-overlay__wrapper')[0];
                _this.bodyLock = false;
                overlay.innerHTML = '';
            }

            _this.openNav = (event, url) => {
                event.preventDefault();
                let navItems = document.querySelectorAll('.header__nav-item');
                if($window.innerWidth < 850) {
                    if(event.currentTarget.nextSibling) {
                        for(var i = 0; i < navItems.length; i++) {
                            navItems[i].classList.remove('current-menu-item', 'current-page-ancestor');
                        }
                        event.currentTarget.parentNode.classList.add('current-menu-item');
                    } else {
                        window.location = url;
                    }
                } else {
                    window.location = url;
                }
            }

        }])

        .directive('stickySlide', ['$window', function($window) {
            return {
                restrict: 'A',
                link: link
            };

            function link(scope, element, attrs) {
                //Slider will be confined inside this container staying between its top and bottom.
                let parent = angular.element('.sidebar__lower');

                //The element that will be sliding with the scroll.
                let slidingElement = angular.element('.sidebar__nav');

                let scroll_min = 248;
                let scroll_max = angular.element('body').height();
                let stickWid = slidingElement[0].offsetWidth - 1;

                function window_scroll() {
                    let win = angular.element(document);
                    let slideBox = slidingElement[0];
                    slideBox.style.width = stickWid + 'px';
                    console.log(`Scroll min: ${scroll_min}; Scroll max: ${scroll_max}; Window: ${win.scrollTop()}`);

                    if(win.scrollTop() >= scroll_min && win.scrollTop() < scroll_max){
                        slideBox.classList.remove('at-bottom');
                        slideBox.classList.add('is-stuck');
                    } else {
                        slideBox.classList.remove('is-stuck');

                        // Do we attach to the bottom now?
                        if(win.scrollTop() > scroll_max) {
                            slideBox.classList.add('at-bottom');
                        }
                    }
                }

                angular.element($window).bind('scroll', window_scroll);
            }
        }]);

})();
